import Statistics from './statistics.vue'
export default (Application) =>{
    let vce = Application.proc.make('VueCustomElement')

    vce.createApp({
        name: "xbt-statistics",
        alias: "统计信息",
        category: "监控", 
        singleton: false,
        showTitle: false,
    }, Statistics)
}